var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"indeterminate":"","rounded":"","color":_vm.mainColor,"active":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }